import styled from "@emotion/styled";

export const Sidebar = styled.div`
  @media (min-width: 768px) {
    display: flex;
    position: absolute;
    top: 40px;
    left: 32px;
    height: calc(100vh - 128px);
  }
`;
